(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["korol-lancement"] && !Shopify.designMode) return;
  try {
    
class KorolLaunch {
  constructor(root) {
    this.root = root;
    this.entryView = root.querySelector('[data-kl-view="entry"]');
    this.flowView = root.querySelector('[data-kl-view="flow"]');
    this.entryForm = root.querySelector('[data-kl-entry-form]');
    this.evergreenForm = root.querySelector('[data-kl-evergreen-form]');
    this.newsletterForm = root.querySelector('[data-kl-newsletter-form]');
    this.preferenceBackend = root.querySelector('[data-kl-preference-backend]');
    this.preferenceForm = root.querySelector('[data-kl-preference-form]');
    this.email = '';
    this.firstName = '';
    this.marketing = false;
    this.params = new URLSearchParams(window.location.search);
    this.source = this.resolveSource();
    this.mode = this.resolvePhase();
    this.entryId = this.makeEntryId();
    this.utm = {
      source: this.safeParam('utm_source'),
      medium: this.safeParam('utm_medium'),
      campaign: this.safeParam('utm_campaign'),
      content: this.safeParam('utm_content'),
      term: this.safeParam('utm_term')
    };
    this.init();
  }

  init() {
    this.root.dataset.activePhase = this.mode;
    this.configurePhase();
    this.fillTracking();
    if (this.entryForm) this.entryForm.addEventListener('submit', (event) => this.submitEntry(event));
    if (this.evergreenForm) this.evergreenForm.addEventListener('submit', (event) => this.submitEvergreen(event));
    this.root.querySelectorAll('[data-kl-to-preferences]').forEach((button) => button.addEventListener('click', () => this.showScreen('preferences')));
    this.root.querySelectorAll('[data-kl-second-optin]').forEach((button) => button.addEventListener('click', () => this.acceptSecondOptin(button)));
    this.root.querySelectorAll('[data-kl-decline-optin]').forEach((button) => button.addEventListener('click', () => this.declineSecondOptin()));
    if (this.preferenceForm) this.preferenceForm.addEventListener('submit', (event) => this.submitPreferences(event));
    this.root.querySelectorAll('[data-kl-skip-preferences]').forEach((button) => button.addEventListener('click', () => this.skipPreferences()));
    const challenge = this.root.querySelector('[data-kl-challenge]');
    if (challenge) {
      challenge.addEventListener('input', () => this.updateCharacterCount(challenge));
      this.updateCharacterCount(challenge);
    }
    this.root.querySelectorAll('.kl-launch__final-actions a').forEach((link) => {
      link.addEventListener('click', () => this.track('kl_collection_click', { kl_destination: this.clean(link.textContent) }));
    });
    this.track('kl_landing_view');
  }

  resolvePhase() {
    const configured = this.root.dataset.campaignMode || 'auto';
    if (configured === 'contest' || configured === 'evergreen') return configured;
    const endAt = Date.parse(this.root.dataset.campaignEnd || '');
    if (Number.isFinite(endAt) && Date.now() >= endAt) return 'evergreen';
    return 'contest';
  }

  configurePhase() {
    const challenge = this.root.querySelector('[data-kl-challenge]');
    if (!challenge) return;
    challenge.disabled = this.mode !== 'contest';
    challenge.required = this.mode === 'contest';
  }

  makeEntryId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return `krol-${window.crypto.randomUUID()}`;
    return `krol-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  }

  safeParam(name) {
    return String(this.params.get(name) || '').trim().replace(/[\r\n<>]+/g, ' ').slice(0, 120);
  }

  resolveSource() {
    const explicit = this.params.get('source') || this.params.get('utm_source');
    if (explicit) return this.clean(explicit);
    try {
      const referrer = new URL(document.referrer);
      if (referrer.hostname && referrer.hostname !== window.location.hostname && !referrer.hostname.endsWith('shopify.com')) {
        return this.clean(referrer.hostname.replace(/^www\./, ''));
      }
    } catch (error) {
      return 'direct';
    }
    return 'direct';
  }

  clean(value) {
    return String(value || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9_-]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 48) || 'direct';
  }

  fillTracking() {
    const map = {
      '[data-kl-source-field]': this.source,
      '[data-kl-campaign-field]': this.root.dataset.campaign || 'launch_2026',
      '[data-kl-utm-source]': this.utm.source,
      '[data-kl-utm-medium]': this.utm.medium,
      '[data-kl-utm-campaign]': this.utm.campaign,
      '[data-kl-utm-content]': this.utm.content,
      '[data-kl-utm-term]': this.utm.term,
      '[data-kl-entry-id]': this.entryId,
      '[data-kl-entry-date]': new Date().toISOString(),
      '[data-kl-entry-phase]': this.mode
    };
    Object.entries(map).forEach(([selector, value]) => {
      const field = this.entryForm ? this.entryForm.querySelector(selector) : null;
      if (field) field.value = value;
    });
  }

  buildTags(preference = '', postal = '') {
    const tags = [
      ...(this.marketing ? ['newsletter', 'krol_marketing_optin'] : ['krol_marketing_excluded']),
      ...(this.mode === 'contest' ? ['contest_entry', 'eligible_18_be', 'password_page'] : []),
      'launch_2026', 'krol_email_hold',
      this.clean(this.root.dataset.campaign || 'launch_2026'),
      `phase_${this.mode}`,
      `source_${this.source}`
    ];
    Object.entries(this.utm).forEach(([key, value]) => {
      if (value) tags.push(`utm_${key}_${this.clean(value)}`);
    });
    if (preference) tags.push(`pref_${this.clean(preference)}`);
    if (postal) tags.push(`cp_${this.clean(postal)}`);
    return [...new Set(tags)].join(',');
  }

  track(eventName, details = {}) {
    const payload = {
      event: eventName,
      kl_campaign: this.clean(this.root.dataset.campaign || 'launch_2026'),
      kl_source: this.source,
      kl_phase: this.mode,
      ...details
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent(`korol:${eventName}`, { detail: payload }));
  }

  async submitEntry(event) {
    event.preventDefault();
    if (!this.entryForm.reportValidity()) return;
    const button = this.entryForm.querySelector('[data-kl-submit]');
    const status = this.entryForm.querySelector('[data-kl-entry-status]');
    const consent = this.entryForm.querySelector('[data-kl-consent]');
    this.email = this.entryForm.querySelector('[data-kl-email]').value.trim();
    this.firstName = this.entryForm.querySelector('[data-kl-first-name]').value.trim();
    this.marketing = consent.checked;
    this.entryForm.querySelector('[data-kl-consent-field]').value = this.marketing ? 'Oui' : 'Non';
    this.entryForm.querySelector('[data-kl-entry-body]').value = `Pré-inscription concours K°ROL | ID: ${this.entryId} | Source: ${this.source} | Marketing: ${this.marketing ? 'oui' : 'non'} | UTM campaign: ${this.utm.campaign || 'non renseigné'} | UTM content: ${this.utm.content || 'non renseigné'}`;
    button.disabled = true;
    status.textContent = 'Enregistrement de la première étape…';

    try {
      await this.subscribe();
      this.track('kl_contest_step_one', { kl_marketing_intent: this.marketing });
      if (this.marketing) this.track('kl_marketing_optin');
      this.openFlow(this.marketing ? 'opted' : 'not-opted');
    } catch (error) {
      status.textContent = 'Un souci est survenu. Cette première étape n’a pas été envoyée. Réessayez dans un instant.';
      button.disabled = false;
    }
  }

  async submitEvergreen(event) {
    event.preventDefault();
    if (!this.evergreenForm.reportValidity()) return;
    const button = this.evergreenForm.querySelector('[data-kl-evergreen-submit]');
    const status = this.evergreenForm.querySelector('[data-kl-evergreen-status]');
    this.email = this.evergreenForm.querySelector('[data-kl-evergreen-email]').value.trim();
    this.firstName = this.evergreenForm.querySelector('[data-kl-evergreen-first-name]').value.trim();
    this.marketing = true;
    this.evergreenForm.querySelector('[data-kl-evergreen-tags]').value = this.buildTags();
    button.disabled = true;
    status.textContent = 'Bienvenue, votre inscription est en cours…';

    try {
      await this.post(this.evergreenForm, 'evergreen');
      this.track('kl_evergreen_signup');
      this.openFlow('preferences');
    } catch (error) {
      status.textContent = 'Votre inscription n’a pas abouti. Réessayez dans un instant.';
      button.disabled = false;
    }
  }

  async acceptSecondOptin(button) {
    const status = this.root.querySelector('[data-kl-optin-status]');
    button.disabled = true;
    status.textContent = 'Confirmation en cours…';
    try {
      this.marketing = true;
      await this.subscribe();
      this.track('kl_marketing_optin', { kl_optin_step: 'second_chance' });
      this.showScreen('opted');
    } catch (error) {
      this.marketing = false;
      status.textContent = 'Votre participation reste bien enregistrée, mais l’inscription K°ROL n’a pas abouti. Vous pouvez réessayer.';
      button.disabled = false;
    }
  }

  declineSecondOptin() {
    this.marketing = false;
    this.track('kl_marketing_declined', { kl_optin_step: 'second_chance' });
    this.showScreen('preferences');
  }

  async subscribe(preference = '', postal = '') {
    this.newsletterForm.querySelector('[data-kl-news-first-name]').value = this.firstName;
    this.newsletterForm.querySelector('[data-kl-news-email]').value = this.email;
    this.newsletterForm.querySelector('[data-kl-news-tags]').value = this.buildTags(preference, postal);
    await this.post(this.newsletterForm, 'newsletter');
  }

  async submitPreferences(event) {
    event.preventDefault();
    if (!this.preferenceForm.reportValidity()) return;
    const button = this.preferenceForm.querySelector('[data-kl-preference-submit]');
    const status = this.preferenceForm.querySelector('[data-kl-preference-status]');
    const selected = this.preferenceForm.querySelector('input[name="preference"]:checked');
    const preference = selected ? selected.value : '';
    const postal = this.preferenceForm.querySelector('[data-kl-postal]').value.trim();
    const challenge = this.preferenceForm.querySelector('[data-kl-challenge]');
    const answer = this.mode === 'contest' && challenge ? challenge.value.trim() : '';
    const backend = this.preferenceBackend;
    backend.querySelector('[data-kl-pref-email]').value = this.email;
    backend.querySelector('[data-kl-pref-value]').value = preference;
    backend.querySelector('[data-kl-pref-postal]').value = postal;
    backend.querySelector('[data-kl-pref-answer]').value = answer;
    backend.querySelector('[data-kl-pref-source]').value = this.source;
    backend.querySelector('[data-kl-pref-consent]').value = this.marketing ? 'Oui' : 'Non';
    backend.querySelector('[data-kl-pref-entry-id]').value = this.entryId;
    backend.querySelector('[data-kl-pref-phase]').value = this.mode;
    backend.querySelector('[data-kl-pref-utm-source]').value = this.utm.source;
    backend.querySelector('[data-kl-pref-utm-medium]').value = this.utm.medium;
    backend.querySelector('[data-kl-pref-utm-campaign]').value = this.utm.campaign;
    backend.querySelector('[data-kl-pref-utm-content]').value = this.utm.content;
    backend.querySelector('[data-kl-pref-subject]').value = this.mode === 'contest' ? 'Participation validée — lancement K°ROL 2026' : 'Préférences — univers K°ROL';
    backend.querySelector('[data-kl-pref-body]').value = `${this.mode === 'contest' ? 'Participation validée' : 'Préférences enregistrées'} | ID: ${this.entryId} | Réponse: ${answer || 'sans objet'} | Préférence: ${preference} | Code postal: ${postal || 'non communiqué'} | Source: ${this.source} | Marketing: ${this.marketing ? 'oui' : 'non'}`;
    button.disabled = true;
    status.textContent = this.mode === 'contest' ? 'Validation de votre participation…' : 'Enregistrement de vos préférences…';

    try {
      await this.post(backend, 'preference');
      let profileUpdated = true;
      if (this.marketing) {
        try {
          await this.subscribe(preference, postal);
        } catch (error) {
          profileUpdated = false;
        }
      }
      this.track(this.mode === 'contest' ? 'kl_contest_complete' : 'kl_preferences_complete', { kl_preference: this.clean(preference) });
      this.showScreen('final');
      if (!profileUpdated) {
        const finalStatus = this.root.querySelector('[data-kl-final-status]');
        if (finalStatus) finalStatus.textContent = 'Votre participation est bien enregistrée. Seule la mise à jour de vos préférences e-mail a rencontré un souci.';
      }
    } catch (error) {
      status.textContent = this.mode === 'contest' ? 'Votre participation n’a pas pu être validée. Réessayez dans un instant.' : 'Vos préférences n’ont pas pu être enregistrées. Vous pouvez réessayer ou passer cette étape.';
      button.disabled = false;
    }
  }

  skipPreferences() {
    this.track('kl_preferences_skipped');
    this.showScreen('final');
  }

  updateCharacterCount(field) {
    const counter = this.root.querySelector('[data-kl-character-count]');
    if (counter) counter.textContent = String(field.value.length);
  }

  async post(form, kind) {
    const response = await fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'text/html' },
      credentials: 'same-origin'
    });
    if (!response.ok) throw new Error(`${kind}-http`);
    const html = await response.text();
    const documentResult = new DOMParser().parseFromString(html, 'text/html');
    const explicitError = documentResult.querySelector(`[data-kl-form-result="${kind}-error"]`);
    if (explicitError) throw new Error(`${kind}-validation`);
    const explicitSuccess = documentResult.querySelector(`[data-kl-form-result="${kind}-success"]`);
    const redirectedSuccess = /(?:contact|customer)_posted=true/.test(response.url);
    if (!explicitSuccess && !redirectedSuccess) throw new Error(`${kind}-unconfirmed`);
    return true;
  }

  openFlow(screen) {
    this.entryView.hidden = true;
    this.flowView.hidden = false;
    this.showScreen(screen, false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  showScreen(name, scroll = true) {
    this.root.querySelectorAll('[data-kl-screen]').forEach((screen) => {
      screen.hidden = screen.dataset.klScreen !== name;
    });
    if (scroll) this.flowView.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const active = this.root.querySelector(`[data-kl-screen="${name}"]`);
    const focusTarget = active ? active.querySelector('h2, h3, input, button') : null;
    if (focusTarget) {
      focusTarget.setAttribute('tabindex', '-1');
      window.setTimeout(() => focusTarget.focus({ preventScroll: true }), 350);
    }
  }
}

document.querySelectorAll('[data-kl-launch]').forEach((root) => new KorolLaunch(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["korol-recharge"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const key = 'korol-refill-email';
      const reminder = root.querySelector('.kr-reminder-form');
      const email = root.querySelector('[data-reminder-email]');
      const consent = root.querySelector('[data-consent]');
      const newsletter = root.querySelector('.kr-newsletter-form');
      const block = root.querySelector('[data-newsletter]');
      if (reminder && email) {
        reminder.addEventListener('submit', () => {
          if (!reminder.checkValidity()) return;
          try {
            sessionStorage.setItem(key, JSON.stringify({
              email: email.value.trim(),
              news: consent ? consent.checked : false,
              time: Date.now()
            }));
          } catch (error) {}
        });
      }
      const success = root.querySelector('[data-reminder-success]');
      const newsletterResult = root.dataset.newsletterResult === 'true';
      if (success || newsletterResult) {
        const newsEmail = root.querySelector('[data-news-email]');
        let saved = null;
        try { saved = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (error) {}
        const fresh = saved && Date.now() - saved.time < 1800000;
        if (fresh && newsEmail) {
          newsEmail.value = saved.email;
          const wrap = root.querySelector('[data-news-email-wrap]');
          if (wrap) wrap.hidden = true;
        }
        if (block && success && fresh && saved.news) block.hidden = false;
        try { sessionStorage.removeItem(key); } catch (error) {}
        (success || root.querySelector('.kr-newsletter-done'))?.focus({ preventScroll: true });
      }
      if (newsletter) {
        newsletter.addEventListener('submit', () => {
          const field = newsletter.querySelector('[data-news-email]');
          if (!newsletter.checkValidity() || !field) return;
          try { sessionStorage.setItem(key, JSON.stringify({ email: field.value.trim(), news: true, time: Date.now() })); } catch (error) {}
        });
      }
    };
    document.querySelectorAll('[data-korol-refill]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-korol-refill]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["korol-redirect"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-kr-redirect]');
    if (!el) return;
    var target = el.getAttribute('data-target');
    var delay = parseInt(el.getAttribute('data-delay'), 10) || 1200;
    if (!target) return;
    window.setTimeout(function () { window.location.replace(target); }, delay);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kretz-cart"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kretz-cart')) {
  customElements.define('kretz-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.form.addEventListener('invalid', event => this.invalidField(event.target), true);
      this.form.addEventListener('input', event => {
        event.target.removeAttribute('aria-invalid');
        const error = event.target.id && this.querySelector('#' + CSS.escape(event.target.id + '-error'));
        if (error) error.textContent = '';
      });
      this.error = this.querySelector('[data-error-output]');
      this.status = this.querySelector('[data-save-status]');
      this.root = window.Shopify?.routes?.root || '/';
      this.querySelector('[data-cadence]').addEventListener('change', () => { this.updateDates(); this.schedule(); });
      this.querySelector('#KretzDate').addEventListener('input', () => this.updateDates());
      this.querySelectorAll('[data-extra-date]').forEach(field => field.addEventListener('input', () => { delete field.dataset.suggested; }));
      this.querySelector('[data-step-back]')?.addEventListener('click', () => this.setStep(1));
      this.querySelector('[data-save-cart]').addEventListener('click', () => this.run(async () => {
        for (const row of this.querySelectorAll('[data-line]')) {
          if (Number(row.querySelector('[data-line-quantity]').value) !== Number(row.dataset.currentQuantity) || [...row.querySelectorAll('[data-edit-property]')].some(f => f.value !== f.defaultValue)) {
            const field=row.querySelector('[data-line-quantity]'); this.invalidField(field, this.dataset.pendingChanges); throw new Error(this.dataset.pendingChanges);
          }
        }
        await this.save(); this.setStep(2);
      }));
      this.querySelector('[data-native-checkout]')?.addEventListener('click', () => this.run(() => this.checkout()));
      this.form.addEventListener('submit', event => { event.preventDefault(); if (this.dataset.step === '2') this.run(() => this.checkout()); });
      for (const row of this.querySelectorAll('[data-line]')) {
        row.querySelector('[data-save-line]').addEventListener('click', () => this.run(() => this.change(row, false)));
        row.querySelector('[data-remove-line]').addEventListener('click', () => this.run(() => this.change(row, true)));
      }
      const date = this.querySelector('#KretzDate');
      const now = new Date();
      date.min = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
      this.updateDates();
      this.schedule();
      if (Number(this.dataset.count) > 0) this.run(() => this.syncPartner());
    }
    dateFields() { return [this.querySelector('#KretzDate'), ...this.querySelectorAll('[data-extra-date]')]; }
    updateDates() {
      const count = Number(this.querySelector('[data-cadence]').value), first = this.querySelector('#KretzDate');
      const months = count === 2 ? 6 : 3;
      this.querySelectorAll('[data-extra-date]').forEach(field => {
        const n = Number(field.dataset.extraDate); field.closest('[data-delivery-date]').hidden = n > count; field.disabled = n > count; field.min = first.min;
        if (!field.value || field.dataset.suggested === 'true') {
          if (first.value) {
            const [y,m,d] = first.value.split('-').map(Number), target = new Date(y,m-1+months*(n-1),1);
            const day = Math.min(d,new Date(target.getFullYear(),target.getMonth()+1,0).getDate());
            field.value = `${target.getFullYear()}-${String(target.getMonth()+1).padStart(2,'0')}-${String(day).padStart(2,'0')}`; field.dataset.suggested = 'true';
          } else { field.value = ''; delete field.dataset.suggested; }
        }
      });
      this.querySelector('[data-date-help]').textContent = first.value ? 'Dates suivantes suggérées et modifiables. Le calendrier sera confirmé par l’atelier.' : 'Calendrier à proposer par l’atelier. Toutes les dates restent facultatives.';
    }
    setStep(step) {
      this.dataset.step = String(step);
      const done = this.querySelector('[data-demo-complete]'); if (done) done.hidden = true;
      const fields = this.querySelector('[data-contact-fields]'); if (fields) fields.hidden = false;
      this.querySelector('[data-step-one]').hidden = step === 2;
      this.querySelector('[data-step-next]').hidden = step === 2;
      const panel = this.querySelector('[data-step-two]'); if (panel) panel.hidden = step === 1;
      this.querySelector('[data-step-indicator]').textContent = this.dataset.demo === 'true' ? (step === 1 ? this.dataset.demoSteps : this.dataset.demoStepTwo) : (step === 1 ? '1. Ma sélection → 2. Avant paiement' : 'Étape 2 sur 2 · Avant paiement');
      if (step === 2) {
        const count=Number(this.querySelector('[data-cadence]').value);
        const dates=this.dateFields().slice(0,count).map((f,i)=>`Livraison ${i+1} : ${f.value ? f.value.split('-').reverse().join('/') : 'à proposer'}`);
        this.querySelector('[data-delivery-summary]').textContent=dates.join(' · ');
        this.querySelector('[data-contact-heading]')?.focus();
      } else this.querySelector('[data-cadence]').focus();
      this.scrollIntoView({block:'start',behavior:'smooth'});
    }
    invalidField(field, message) {
      if (!field?.id) return;
      const details = field.closest('details'); if (details) details.open = true;
      field.setAttribute('aria-invalid', 'true');
      let error = this.querySelector('#' + CSS.escape(field.id + '-error'));
      if (!error) {
        error = document.createElement('p'); error.id = field.id + '-error';
        error.className = 'kretz-error'; error.setAttribute('role', 'alert');
        field.insertAdjacentElement('afterend', error);
        field.setAttribute('aria-describedby', [field.getAttribute('aria-describedby'), error.id].filter(Boolean).join(' '));
      }
      error.textContent = message || field.validationMessage;
      this.error.textContent = message || this.dataset.invalidFields;
      field.scrollIntoView({block: 'center'}); field.focus();
    }
    async api(path, data) {
      const response = await fetch(this.root + path, {method: data ? 'POST' : 'GET', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, ...(data ? {body: JSON.stringify(data)} : {})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || this.dataset.error);
      return result;
    }
    async run(task) {
      if (this.busy) return;
      this.busy = true;
      this.error.textContent = ''; this.status.textContent = '';
      const buttons = [...this.querySelectorAll('button')];
      const disabled = buttons.map(button => button.disabled);
      buttons.forEach(button => button.disabled = true);
      this.setAttribute('aria-busy', 'true');
      try { await task(); } catch (error) { this.error.textContent = error.message || this.dataset.error; }
      finally { this.busy = false; this.removeAttribute('aria-busy'); buttons.forEach((button, index) => button.disabled = disabled[index]); }
    }
    async syncPartner() {
      await this.api('cart/update.js', {attributes: {
        'Code partenaire': this.dataset.code,
        'Code partenaire demandé': '',
        'Avantages partenaire': this.dataset.benefits
      }});
    }
    schedule() {
      const cadence = Number(this.querySelector('[data-cadence]').value);
      const groups = new Map();
      for (const row of this.querySelectorAll('[data-line][data-partner="true"]')) {
        const id = row.dataset.product;
        const group = groups.get(id) || {title: row.dataset.title, total: 0};
        group.total += Number(row.dataset.currentQuantity);
        groups.set(id, group);
      }
      const area = this.querySelector('[data-schedule]');
      if (!groups.size) return;
      const list = document.createElement('ul'); list.className = 'kretz-delivery-list';
      this.plan = [];
      for (const group of groups.values()) {
        const base = Math.floor(group.total / cadence), remainder = group.total % cadence;
        const deliveries = Array.from({length: cadence}, (_, index) => base + (remainder > 0 && index >= cadence - remainder ? 1 : 0));
        
        const description = `${group.title} : ${deliveries.join(' + ')} = ${group.total}`;
        const li = document.createElement('li');
        li.textContent = description;
        list.append(li); this.plan.push(description);
      }
      const heading = document.createElement('p'); heading.textContent = this.dataset.distribution;
      area.replaceChildren(heading, list);
    }
    async save() {
      const count = Number(this.querySelector('[data-cadence]').value); let previous = '';
      for (const date of this.dateFields().slice(0,count)) {
        if (date.value && (date.value < date.min || (previous && date.value <= previous))) { const message = date.value < date.min ? this.dataset.dateError : 'Choisissez une date après la livraison précédente.'; this.invalidField(date,message); throw new Error(message); }
        if(date.value) previous=date.value;
      }
      const attributes = {};
      for (const input of this.querySelectorAll('[name^="attributes["]')) attributes[input.name.slice(11, -1)] = input.type === 'checkbox' ? (input.checked ? input.value : '') : input.value.trim();
      this.dateFields().slice(1).forEach((field,i) => { attributes['Réception souhaitée — livraison '+(i+2)] = i+2 <= count ? field.value : ''; });
      attributes['Code partenaire'] = this.dataset.code;
      attributes['Code partenaire demandé'] = '';
      attributes['Avantages partenaire'] = this.dataset.benefits;
      this.schedule();
      attributes['Répartition indicative par modèle'] = (this.plan || []).join('\n');
      attributes['Type de commande'] = this.querySelector('[data-cadence]').value === '1' ? 'Commande ponctuelle' : 'Programme annuel';
      await this.api('cart/update.js', {attributes, note: this.querySelector('[name="note"]').value});
      this.status.textContent = this.dataset.saved;
    }
    async checkout() {
      const agency = this.querySelector('#KretzAgency'), consent = this.querySelector('#KretzDateConsent');
      if (!agency.value.trim()) { this.invalidField(agency, 'Indiquez le nom de votre agence ou de votre entité à facturer.'); return; }
      if (!consent.checked) { this.invalidField(consent, 'Confirmez que les dates souhaitées restent à valider avec l’atelier.'); return; }
      await this.save();
      const cart = await this.api('cart.js');
      if (!cart.items.length || cart.attributes['Agence KRETZ'] !== agency.value.trim() || cart.attributes['Dates souhaitées à confirmer'] !== 'Accepté') throw new Error(this.dataset.error);
      if (this.dataset.demo === 'true') {
        this.status.textContent = '';
        this.querySelector('[data-contact-fields]').hidden = true;
        this.querySelector('[data-demo-complete]').hidden = false;
        this.querySelector('[data-demo-heading]').focus();
        this.querySelector('[data-demo-complete]').scrollIntoView({block:'center',behavior:'smooth'});
        return;
      }
      window.location.assign(this.dataset.checkoutUrl);
    }
    async change(row, remove) {
      const quantity = remove ? 0 : Number(row.querySelector('[data-line-quantity]').value);
      if (!Number.isSafeInteger(quantity) || quantity < (remove ? 0 : 1) || quantity > 10000) { this.invalidField(row.querySelector('[data-line-quantity]'), this.dataset.quantityError); throw new Error(this.dataset.quantityError); }
      const cart = await this.api('cart.js');
      const current = cart.items.find(item => item.key === row.dataset.line);
      if (!current) {
        // Another cart update may have changed the line key: refresh rather than remove the wrong item.
        location.reload();
        return;
      }
      if (remove) {
        // Removing a line must not depend on saving delivery dates or other form fields.
        await this.api('cart/change.js', {id: current.key, quantity: 0});
        location.reload();
        return;
      }
      const properties = {...current.properties};
      if (row.dataset.partner === 'true') { properties['Code partenaire'] = this.dataset.code; properties['Avantages partenaire'] = this.dataset.benefits; }
      for (const input of row.querySelectorAll('[data-edit-property]')) properties[input.dataset.editProperty] = input.value.trim();
      await this.save();
      await this.api('cart/change.js', {id: current.key, quantity, properties});
      location.reload();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kretz-help"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('krol-delivery-planner')) {
  customElements.define('krol-delivery-planner', class extends HTMLElement {
    connectedCallback() {
      const form = this.closest('form');
      if (!form || this.initialized) return;
      this.form = form;
      this.initialized = true;
      this.quantity = form.querySelector('#KD-qte');
      this.model = form.querySelector('#KD-type');
      this.count = this.querySelector('[data-deliveries]');
      this.result = this.querySelector('[data-result]');
      this.perDelivery = this.querySelector('[data-per-delivery]');
      this.total = this.querySelector('[data-total]');
      this.plan = this.querySelector('[data-plan]');
      this.onUpdate = () => this.update();
      this.quantity.addEventListener('input', this.onUpdate);
      this.model.addEventListener('change', this.onUpdate);
      this.count.addEventListener('change', this.onUpdate);
      this.onReset = () => queueMicrotask(this.onUpdate);
      form.addEventListener('reset', this.onReset);
      this.update();
    }
    disconnectedCallback() {
      this.quantity?.removeEventListener('input', this.onUpdate);
      this.model?.removeEventListener('change', this.onUpdate);
      this.count?.removeEventListener('change', this.onUpdate);
      this.form?.removeEventListener('reset', this.onReset);
      this.initialized = false;
    }
    format(template, values) {
      return template.replace(/\{(\w+)\}/g, (match, key) => values[key] ?? match);
    }
    update() {
      const multiple = this.model.selectedOptions[0]?.value.trim() === this.dataset.multipleValue;
      this.quantity.disabled = multiple;
      this.quantity.required = !multiple;
      for (const field of [this.perDelivery, this.total, this.plan]) {
        field.value = '';
        field.disabled = true;
      }
      this.result.hidden = false;
      if (multiple) {
        this.result.textContent = this.dataset.multiple;
        return;
      }
      if (!this.quantity.value) {
        this.result.textContent = '';
        this.result.hidden = true;
        return;
      }
      const requested = this.quantity.valueAsNumber;
      const count = Number(this.count.value);
      const min = Number(this.quantity.min) || 1;
      if (!this.quantity.validity.valid || !Number.isSafeInteger(requested) || requested < min || ![1, 2, 4].includes(count)) {
        this.result.textContent = this.format(this.dataset.invalid, {min});
        return;
      }
      const base = Math.floor(requested / count);
      const remainder = requested % count;
      const deliveries = Array.from({length: count}, (_, index) => base + (index >= count - remainder ? 1 : 0));
      const total = requested;
      const distribution = deliveries.join(' + ');
      const values = {requested, count, distribution, total};
      const summary = this.format(this.dataset.summary, values);
      this.result.textContent = summary;
      this.perDelivery.value = distribution;
      this.total.value = String(total);
      this.plan.value = summary;
      for (const field of [this.perDelivery, this.total, this.plan]) field.disabled = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["krol-weinvest"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('krol-weinvest-copy')) {
  customElements.define('krol-weinvest-copy', class extends HTMLElement {
    connectedCallback() {
      this.formArea = this.querySelector('.kw-app-form');
      this.panel = this.querySelector('[data-kw-copy-panel]');
      this.button = this.querySelector('[data-kw-copy-button]');
      this.discoverLink = this.querySelector('[data-kw-discover]');
      this.status = this.querySelector('[data-kw-copy-status]');
      this.manual = this.querySelector('[data-kw-copy-manual]');
      this.input = this.querySelector('[data-kw-copy-input]');
      if (!this.formArea || !this.button || this.observer) return;
      this.roots = new WeakSet();
      this.observer = new MutationObserver(() => this.scheduleScan());
      this.onCopy = () => this.copyCode();
      this.button.addEventListener('click', this.onCopy);
      this.scan();
      this.discovery = window.setInterval(() => this.scan(), 1000);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      window.clearInterval(this.discovery);
      window.clearTimeout(this.scanTimer);
      this.button?.removeEventListener('click', this.onCopy);
    }

    scheduleScan() {
      window.clearTimeout(this.scanTimer);
      this.scanTimer = window.setTimeout(() => this.scan(), 60);
    }

    isVisible(element) {
      for (let current = element; current; current = current.parentElement || current.getRootNode().host) {
        const style = window.getComputedStyle(current);
        if (current.hidden || current.getAttribute('aria-hidden') === 'true' || style.display === 'none' || style.visibility === 'hidden') return false;
      }
      return element.getClientRects().length > 0;
    }

    scan() {
      if (!this.isConnected || !this.observer) return;
      let code = '';
      const inspect = (root) => {
        if (!this.roots.has(root)) {
          this.roots.add(root);
          this.observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'style', 'class', 'aria-hidden'] });
        }
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          const parent = node.parentElement;
          if (!parent || parent.closest('script, style, textarea, input, template, noscript')) continue;
          const match = /\bWEINVEST[A-Z0-9-]+\b/.exec(node.nodeValue);
          if (match && this.isVisible(parent)) code = match[0];
        }
        root.querySelectorAll('*').forEach((element) => {
          if (element.shadowRoot) inspect(element.shadowRoot);
        });
      };
      inspect(this.formArea);
      if (code !== this.code) {
        this.code = code;
        this.button.textContent = this.dataset.copyLabel;
        this.status.textContent = '';
        this.manual.hidden = true;
        this.discoverLink.hidden = true;
      }
      this.panel.hidden = !code;
      if (code) window.clearInterval(this.discovery);
    }

    async copyCode() {
      if (!this.code || this.copying) return;
      const code = this.code;
      this.copying = true;
      this.button.setAttribute('aria-busy', 'true');
      let copied = false;
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(code);
          copied = true;
        }
      } catch {}
      if (!copied) {
        const field = document.createElement('textarea');
        field.value = code;
        field.readOnly = true;
        field.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;font-size:16px;';
        document.body.appendChild(field);
        try {
          field.focus({ preventScroll: true });
          field.select();
          field.setSelectionRange(0, code.length);
          copied = document.execCommand('copy');
        } catch {} finally {
          field.remove();
          this.button.focus({ preventScroll: true });
        }
      }
      this.button.removeAttribute('aria-busy');
      this.copying = false;
      if (code !== this.code || !this.isConnected) return;
      if (copied) {
        this.button.textContent = this.dataset.copiedLabel;
        this.status.textContent = this.dataset.copiedMessage;
        this.manual.hidden = true;
        this.discoverLink.hidden = false;
      } else {
        this.button.textContent = this.dataset.copyLabel;
        this.status.textContent = this.dataset.copyError;
        this.manual.hidden = false;
        this.input.value = code;
        this.input.focus({ preventScroll: true });
        this.input.select();
        this.input.setSelectionRange(0, code.length);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
